/** Home page section ids — used in routes, navbar, and scroll targets. */
export const HOME_SECTION_IDS = [
  "problem",
  "emotional-hit",
  "live-demo",
  "use-cases",
  "trust",
  "why-ava",
  "social-proof",
  "pricing",
  "faqs",
] as const;

export type HomeSectionId = (typeof HOME_SECTION_IDS)[number];

export function isHomeSectionId(value: string): value is HomeSectionId {
  return (HOME_SECTION_IDS as readonly string[]).includes(value);
}

export function homeSectionPath(sectionId: HomeSectionId | string): string {
  return `/${sectionId}`;
}

export function sectionIdFromPathname(pathname: string): string | null {
  const id = pathname.replace(/^\//, "").split("/")[0];
  if (!id || id === "") return null;
  return isHomeSectionId(id) ? id : null;
}

/** Chat widget inside the live-demo section (scroll target for CTAs). */
export const LIVE_DEMO_CHAT_ID = "live-demo-chat";

const NAVBAR_SCROLL_OFFSET_PX = 80;

export function scrollToLiveDemoChat(behavior: ScrollBehavior = "smooth"): boolean {
  const el = document.getElementById(LIVE_DEMO_CHAT_ID);
  if (!el) {
    return scrollToHomeSection("live-demo", behavior);
  }
  const top =
    el.getBoundingClientRect().top + window.scrollY - NAVBAR_SCROLL_OFFSET_PX;
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

/** Scroll to the chat demo and enter interactive mode (Talk to Ava CTAs). */
export function openLiveDemoChat(talkDelayMs = 700): void {
  scrollToLiveDemoChat("smooth");
  window.setTimeout(() => {
    window.dispatchEvent(new CustomEvent("ava-talk-now"));
  }, talkDelayMs);
}

export function scrollToHomeSection(
  sectionId: string,
  behavior: ScrollBehavior = "smooth"
): boolean {
  if (sectionId === "live-demo") {
    return scrollToLiveDemoChat(behavior);
  }
  const el = document.getElementById(sectionId);
  if (!el) return false;
  el.scrollIntoView({ behavior, block: "start" });
  return true;
}
